import { render, staticRenderFns } from "./PricePlansPage.vue?vue&type=template&id=509d58d8&"
import script from "./PricePlansPage.vue?vue&type=script&lang=ts&"
export * from "./PricePlansPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports